import React, { useState } from "react";
import "../App.css";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

export default function ContactForm() {
  const whatsappNumber = "918660426964";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const validateForm = () => {
    const nameRegex = /^[A-Za-z ]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!nameRegex.test(formData.name)) return "Please enter a valid name.";
    if (!emailRegex.test(formData.email)) return "Please enter a valid email.";
    if (!phoneRegex.test(formData.phone))
      return "Phone number must be exactly 10 digits.";
    if (formData.message.trim().length < 3)
      return "Message cannot be empty.";

    return null;
  };

  const sendToWhatsApp = (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    const message = `New Inquiry from Website:
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Message: ${formData.message}
Source: Website Contact Form`;

    const encodedMessage = encodeURIComponent(message);

    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, "_blank");

    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Contact Us</h2>

      <div className="contact-container container">

        {/* LEFT INFO */}
        <div className="contact-info">
          <div className="info-box">
            <FaPhoneAlt className="icon" />
            <a href="tel: +918660426964" className="link-call">
              +91 8660426964
            </a>
          </div>

          <div className="info-box">
            <FaEnvelope className="icon" />
     

        <a
        href={
             /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
               ? "mailto:info@kk-realtors.in?subject=Website%20Inquiry"
               : "https://mail.google.com/mail/?view=cm&fs=1&to=info@kk-realtors.in&su=Website%20Inquiry"
             }
              target="_blank"
             rel="noopener noreferrer"
              className="link-email"
        >
          info@kk-realtors.in
        </a>


          </div>

          <div className="info-box">
            <FaWhatsapp className="icon" />
            <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="info-box">
            <FaMapMarkerAlt className="icon" />
            <a
              href="https://www.google.com/maps?q=Bengaluru,Karnataka"
              target="_blank"
              rel="noreferrer"
            >
              Bengaluru, Karnataka
            </a>
          </div>
        </div>

        {/* FORM */}
        <form className="contact-form" onSubmit={sendToWhatsApp}>
          {error && <p style={{ color: "red", fontWeight: "600" }}>{error}</p>}

          <input name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} />
          <input name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} />
          <input name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} />
          <textarea name="message" placeholder="Your Message" rows="5" value={formData.message} onChange={handleChange}></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>

      {/* FIXED GOOGLE MAP */}
      <div className="map-container">
  <iframe
    title="Exact Location - KK Realtors"

  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d622.0043013724168!2d77.617087!3d12.8783997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDUyJzQyLjIiTiA3N8KwMzcnMDEuNSJF!5e1!3m2!1sen!2sin!4v1735939200000!5m2!1sen!2sin"

    style={{ width: "100%", height: "400px", border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

    </section>
  );
}
